import ShortenedTitle from "components/General-UI/ShortenedTitle";
import { ADMIN_CODE } from "constants/constants";
import { makeAdmin, removeAsAdmin, removeFromEffice } from "slices/peopleSlice";
import { setConfirmationModal } from "slices/textSlice";
import { store } from "Store";

const permissionsOptions = ({
  permissionsEffice,
  other_role_id,
  setLoading,
  user_id,
}) => {
  let list = [];
  if (permissionsEffice.role_id === ADMIN_CODE) {
    if (other_role_id === ADMIN_CODE) {
      list = [
        {
          text: "Remove As Admin",
          action: () => {
            setLoading(true);
            store
              .dispatch(removeAsAdmin(permissionsEffice.id, user_id))
              .catch(() => setLoading(false))
              .finally(() => setLoading(false));
          },
          danger: true,
        },
      ];
    } else {
      list = [
        {
          text: "Make Admin",
          action: () => {
            store.dispatch(
              setConfirmationModal({
                header: "Make Admin?",
                content: (
                  <>
                    As an admin this person will be able to add and remove
                    anyone into{" "}
                    <span className="font-bold private-dark-color">
                      <ShortenedTitle
                        title={permissionsEffice.content}
                        maxChars={100}
                      />
                    </span>
                    , and make branches inside.
                  </>
                ),
                action: () => {
                  setLoading(true);
                  store
                    .dispatch(makeAdmin(permissionsEffice.id, user_id))
                    .catch(() => setLoading(false))
                    .finally(() => setLoading(false));
                },
                danger: true,
              })
            );
          },
          danger: true,
        },
      ];
    }
    list = list.concat([
      {
        text: (
          <>
            Remove from&nbsp;
            <span className="font-bold private-dark-color">
              {permissionsEffice.content}
            </span>
          </>
        ),
        action: () => {
          setLoading(true);
          store
            .dispatch(removeFromEffice(permissionsEffice.id, user_id))
            .catch(() => setLoading(false))
            .finally(() => setLoading(false));
        },
        danger: true,
      },
    ]);
  }
  return list;
};

export default permissionsOptions;
